import React, { useState } from "react";
import { Button, Card, Form, Input, Modal } from 'antd';
import { useDispatch, useSelector } from "react-redux";
import authService from "../services/auth.service";
import auther from "../actions/auth.js";
import { CheckCircleOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import axios from "axios";

function SmsSecurity() {

    const [loading, setLoading] = useState(false);
    const [code, setCode] = useState([]);
    const { auth } = useSelector(state => state.auth);
    const { sendUserInfo } = useSelector(state => state.auth);
    const { error } = Modal;
    const [upData, setUpData] = useState([]);
    const [form] = Form.useForm();

    const dispatch = useDispatch();

    /*  const sendSms = (values) => {
  
          const {
              code, isApiUser, username, password,
          } = values;
  
          setLoading(true);
  
          dispatch(login(code, isApiUser, sendUserInfo.auth.username, sendUserInfo.auth.password))
              .then(() => {
                  localStorage.setItem("token");
              })
              .catch(() => {
                  setLoading(false);
              });
  
      };*/


    /*  const sendSmsSecurityCode = (smsCode) => {
          console.log(`Kod: ${smsCode}`);
          console.log(code);
              axios("https://localhost:8082/authservice-api/auth/login", {
                  method: 'GET',
                  params: { code : smsCode, isApiUser: null},
                  headers: {username : null  , password: null},
              })
                  .then((response) => {
                           console.log(response);
                           window.open('/authservice-ui/resetPassword', "_self");
                      }
                  )
                  .catch((error) => {
                      console.error(error);
                  });
      };*/



    /*const sendSmsSecurityCode = (values) => {
        const {
            code,
            isApiUser,
            username,
            password,
        } = values;
        authService.login(code, isApiUser, username, password)
            .then(res => {
                console.log(res.token);
                localStorage.setItem("token", "Bearer "+ res.token);
            }).catch(error => {
            localStorage.removeItem("token");
        });

    };*/

    const sendSmsSecurityCode = (values) => {
        setLoading(true)
        const {
            code,
            isApiUser,
            username = sessionStorage.getItem("username"),
            password = sessionStorage.getItem("password"),
        } = values;
        // console.log("sendSms" +  username);
        // console.log("sendSms" +  password);
        authService.login(code, isApiUser, username, password)
            .then(res => {
                if (res && res.validated && res.validated === true) {
                    if (res.token) {
                        // console.log(res.token);
                        localStorage.setItem("token", "Bearer " + res.token);
                        window.open('/CreditSystem/index.html', "_self");
                    } else {
                        error({
                            title: 'Hata',
                            icon: <ExclamationCircleOutlined />,
                            content: "Geçersiz SMS Kodu!",
                            okText: 'Tamam',
                            onOk() {
                                setLoading(false)
                                // afterClose: window.open('/authservice-ui/index.html', "_self")
                                form.setFieldsValue({
                                    code: null,
                                })
                            },
                        });
                    }
                } else {
                    error({
                        title: 'Hata',
                        icon: <ExclamationCircleOutlined />,
                        content: "Kullanıcı adı ve parolayı tekrar giriniz",
                        okText: 'Tamam',
                        onOk() {
                            setLoading(false)
                            window.open('/authservice-ui/index.html', "_self");
                        },
                    });
                }

            }).catch(err => {
                localStorage.removeItem("token");
                error({
                    title: 'Hata',
                    icon: <ExclamationCircleOutlined />,
                    content: "Geçersiz SMS Kodu!",
                    okText: 'Tamam',
                    onOk() {
                        // afterClose: window.open('/authservice-ui/index.html', "_self")
                        setLoading(false)
                        form.setFieldsValue({
                            code: null,
                        })
                    },
                });
            });

    };

    // console.log("Sonnnn")

    const sendSmsCodeByEmail = () => {
        const username = sessionStorage.getItem("username");
        axios("/authservice-api/auth/smsCodeSendEmail/", {
            method: 'POST',
            headers: { 'username': username },
        })
            .then((res) => {
                // console.log(res);
                if (res && res.data.code && res.data.code === "0000") {
                    error({
                        title: 'Başarılı',
                        icon: <CheckCircleOutlined />,
                        content: "Sms kodunuz e-posta adresinize gönderildi.",
                        okText: 'Tamam',
                    });
                } else {
                    error({
                        title: 'Hata',
                        icon: <ExclamationCircleOutlined />,
                        content: "Hata oluştu sistem yöneticinize başvurunuz.",
                        okText: 'Tamam',
                    });
                }
            }
            )
            .catch((err) => {
                console.error(err);
                error({
                    title: 'Hata',
                    icon: <ExclamationCircleOutlined />,
                    content: "Lütfen sistem yöneticinize başvurunuz.",
                    okText: 'Tamam',
                });
            });

    };



    /*  if (isSmsSend) {
          window.open('/CreditSystem/index.html', "_self");
          this.props.history.push('/CreditSystem/index.html');
      }*/

    return (

        <div className="form_design">
            <Card title="Sms Kodu">
                <Form form={form} onFinish={sendSmsSecurityCode}>
                    <Form.Item name="code" rules={[{ required: true, message: 'Lütfen telefonunuza gelen sms kodunuzu giriniz' }]}
                    >
                        <Input
                            size="large"
                            placeholder="Sms Kodu"
                            value={code}>
                        </Input>
                    </Form.Item>

                    {/*<Form.Item name="code" className="input_border"
                               rules={[{required: true, message: 'Telefonunuza gelen sms kodunu giriniz'}]}>
                        <Input placeholder='Sms Kodu' autoComplete="code"/>
                    </Form.Item>*/}
                    <Form.Item>
                        <Button size="large" type="primary" htmlType="submit" disabled={loading} block>
                            Giriş Yap
                        </Button>
                    </Form.Item>
                    <Form.Item>
                        <Button size="large" type="primary" onClick={sendSmsCodeByEmail} block>
                            E-posta Gönder
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );


};

export default SmsSecurity;